import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { CircularProgress, Typography } from "@mui/material";
import { loginRequest } from "auth/microsoft";
import { AlertHelper } from "helpers";
import { EAlertType } from "helpers/alertHelper";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { IdentityActions } from "redux/actions";
import {
  useAppDispatch,
  useAppSelector,
} from "redux/configurations/reduxHooks";
import { RootReducer } from "redux/configurations/rootReducer";
import { I18nTranslator, translations } from "utils/i18n";

const Authenticator = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { accounts, instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [process, setProcess] = useState<string>(translations.login.signing);
  const activeAccount = instance.getActiveAccount();
  const action = useSelector(
    (state: RootReducer) => state.IdentityReducer.action
  );
  const deviceId = useAppSelector((state) => state.IdentityReducer.deviceId);

  useEffect(() => {
    if (action.includes(IdentityActions.getCurrentUser.successName)) {
      history.push("/master-data/product-configuration");
      dispatch(IdentityActions.clearAction.request());
    }
  }, [action]);

  const handelLogin = () => {
    const activeAccount = instance.getActiveAccount();

    if (activeAccount) {
      setProcess(translations.login.gettingInfo);

      setTimeout(() => {
        instance
          .acquireTokenSilent({
            ...loginRequest,
            account: activeAccount,
          })
          .then((res) => {
            if (res.accessToken) {
              setProcess(translations.login.loginSuccess);
              setTimeout(() => {
                dispatch(
                  IdentityActions.microsoftAzureAuthenticate.request(res)
                );
                // dispatch(
                //   IdentityActions.pingAuthenticate.request({
                //     accessToken: res.accessToken,
                //     deviceId,
                //   })
                // ); //chua sua
              }, 1500);
            }
          })
          .catch((err) => {
            if (err instanceof InteractionRequiredAuthError) {
              instance
                .loginRedirect({
                  ...loginRequest,
                  redirectUri: "/login",
                })
                .catch(() => {
                  AlertHelper.showAlert(
                    I18nTranslator(translations.login.loginFailed),
                    EAlertType.ERROR
                  );
                  localStorage.clear();
                  history.replace("/login");
                  dispatch(IdentityActions.logout.request());
                });
            } else {
              AlertHelper.showAlert(
                I18nTranslator(translations.login.loginFailed),
                EAlertType.ERROR
              );
              localStorage.clear();
              history.replace("/login");
              dispatch(IdentityActions.logout.request());
            }
          });
      }, 1500);
    } else {
      localStorage.clear();
      history.replace("/");
    }
  };

  useEffect(() => {
    handelLogin();
  }, []);

  return (
    <div
      style={{
        flex: 1,
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <CircularProgress
        color={"primary"}
        style={{
          marginBottom: 20,
        }}
      />
      <Typography>{I18nTranslator(process)}</Typography>
    </div>
  );
};

export default Authenticator;
